import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import LoginModal from '../LoginModal/loginModal';
import RegisterModal from '../Register/RegisterModal';
import Logo12 from '../../assets/Logo-RB.png';
import Logo from '../../assets/lisa.jpg';

const glass = css`
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
`;

const pill = css`
  border-radius: 999px;
  font-family: 'Chau Philomene One';
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease, color 0.18s ease,
    border-color 0.18s ease;
  &:active {
    transform: translateY(0px) scale(0.98);
  }
`;

const NavbarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1.6rem;
  z-index: 1000;

  /* Green-tinted glass */
  ${glass}
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.16) 0%,
    rgba(19, 111, 7, 0.18) 55%,
    rgba(19, 111, 7, 0.22) 100%
  );
  border-left: none;
  border-right: none;
  border-top: none;

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 54px;
  margin-right: 10px;

  @media (max-width: 768px) {
    height: 46px;
  }
`;

const MainTextWrapper = styled.div`
  font-size: 1.7rem;
  font-weight: 800;
  color: rgba(10, 20, 10, 0.92);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.35);

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const GlassButton = styled.button`
  ${pill}
  padding: 0.75rem 1.4rem;
  font-size: 1.02rem;

  /* Default: white glass pill */
  ${glass}
  background: rgba(255, 255, 255, 0.58);
  color: rgba(10, 65, 15, 0.95);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 35px rgba(0, 0, 0, 0.22);
    background: rgba(255, 255, 255, 0.68);
  }

  @media (max-width: 768px) {
    padding: 0.65rem 1.05rem;
    font-size: 0.95rem;
  }
`;

const AccentButton = styled(GlassButton)`
  /* Green glass on hover */
  border-color: rgba(255, 255, 255, 0.26);

  &:hover {
    background: rgba(19, 111, 7, 0.78);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.22);
  }
`;

const LisaButton = styled(GlassButton)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const LisaLogo = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 6px;
`;

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem('currentUser');
    if (user) setCurrentUser(JSON.parse(user));
  }, []);

  const handleLoginClick = () => {
    setLoginModalOpen(true);
    setRegisterModalOpen(false);
  };

  const handleRegisterClick = () => {
    setRegisterModalOpen(true);
    setLoginModalOpen(false);
  };

  const handleCloseModals = () => {
    setLoginModalOpen(false);
    setRegisterModalOpen(false);
  };

  return (
    <>
      <NavbarContainer>
        <LogoWrapper>
          <LogoImage src={Logo12} alt="Logo" />
          <MainTextWrapper>Modeling Agricultural Knowledge using AI for Sustainable Agriculture</MainTextWrapper>
        </LogoWrapper>

        <ButtonGroup>
    

          <AccentButton onClick={() => navigate('/projects')}>Projects</AccentButton>
         
          <AccentButton onClick={() => navigate('/about')}>About</AccentButton>

          {currentUser ? (
            <AccentButton
              onClick={() => {
                localStorage.removeItem('currentUser');
                setCurrentUser(null);
                alert('Logged out!');
              }}
            >
              Logout
            </AccentButton>
          ) : (
            <AccentButton onClick={handleLoginClick}>Login</AccentButton>
          )}
        </ButtonGroup>
      </NavbarContainer>

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={handleCloseModals}
        onSwitchToRegister={handleRegisterClick}
      />

      <RegisterModal
        isOpen={isRegisterModalOpen}
        onClose={handleCloseModals}
        onSwitchToLogin={handleLoginClick}
      />
    </>
  );
};

export default Navbar;
